// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"aws":"1c51f00d","lsc":"c2f7905b","others":"40bceab6"}[chunkId] + ".chunk.js";
};